














































































































































































































import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import UnitDetailMixin from '@/components/mixins/UnitDetailListMixin.vue'
import BeaconModel from '@/_models/BeaconModel'
@Component({
  components: {},
})
export default class BeaconList extends Mixins(UnitDetailMixin) {
  public filedNameLUT: any = {
    _id: 'UUID',
    beacon_uuid: 'label.beacon_uuid',
    user_name: 'label.username',
    user_id: 'label.user_id',
    category_name: 'label.category_name',
    location_name: 'label.possition',
    major: 'label.major',
    minor: 'label.minor',
    lon: 'label.lon',
    lat: 'label.lat',
    floor_name: 'label.floor',
    floor_id: 'label.floor_id',
  }

  public pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'major',
    searchQuery: '',
    activeTab: 0, // 1: carried, 0: static
  }

  get beacons(): BeaconModel[] {
    const beacons = this.$store.state.units.all.beacons
    if (!beacons.length) {
      return []
    }

    this.numofPage = Math.ceil(beacons.length / this.pageFilters.perPage)

    return beacons
  }

  get totalBeaconsStatic(): number {
    return this.beacons.filter(
      (item: BeaconModel) => item.beacon_type === 'static'
    ).length
  }

  get totalBeaconsCarried(): number {
    return this.beacons.filter(
      (item: BeaconModel) => item.beacon_type === 'carried'
    ).length
  }

  get filteredData(): BeaconModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.beacons) {
      return []
    }

    return this.beacons.filter((item: any): boolean => {
      const searchKey =
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.pageFilters.searchQuery.toString().toLowerCase()) !==
          -1 || item._id === this.pageFilters.searchQuery // Can search by uuid

      const validCarried =
        item.beacon_type === 'carried' && this.pageFilters.activeTab === 1
      const validStatic =
        item.beacon_type === 'static' && this.pageFilters.activeTab === 0

      return searchKey && (validCarried || validStatic)
    })
  }

  public confirmMultiDelete() {
    const ids = this.checkedRows.map((item: BeaconModel) => item._id)
    const labels = this.checkedRows.map((item: BeaconModel) => `[${item.beacon_type}] - [${item.beacon_uuid}] - ${item.major}/${item.minor}`)
    this.handleConfirmMultipleDelete('beacon', ids, labels)
  }

  public confirmSingleDelete(selectedItem: BeaconModel) {
    const ids = [selectedItem._id]
    const labels = [`[${selectedItem.beacon_type}] - [${selectedItem.beacon_uuid}] - ${selectedItem.major}/${selectedItem.minor}`]
    this.handleConfirmMultipleDelete('beacon', ids, labels)
  }

  private created() {
    this.$store.dispatch('units/getAllBeacons', this.selected)
  }
}
